export default import.meta.ROLLDOWN_FILE_URL_ogpS0e$gcQpyhs$Ta8AR7A